const formatAmount = (amount) => {
  if (!isNaN(amount)) {
    amount = Number(amount);

    // Round the amount to 2 decimal places to avoid floating-point precision issues
    amount = Math.round(amount * 100) / 100;

    // Check if the amount is a whole number. If it is, we don't want decimal points.
    const isWholeNumber = amount % 1 === 0;

    // Create an options object that we will pass to our Intl.NumberFormat instance.
    const formatOptions = {
      style: 'decimal',
      minimumFractionDigits: isWholeNumber ? 0 : 2,
      maximumFractionDigits: isWholeNumber ? 0 : 2
    };

    const formattedAmount = new Intl.NumberFormat('en-US', formatOptions).format(amount);
    return formattedAmount;
  }
  return "Not a number";
};

const formatAmountRound = (amount) => {
  if (!isNaN(amount)) {
    amount = Number(amount);

    // Round the amount down to the nearest whole number using Math.floor
    const roundedAmount = Math.floor(amount);

    // Use the same formatting logic as in formatAmount but for the rounded value
    const formattedAmount = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(roundedAmount);

    return formattedAmount;
  }
  return "Not a number";
};

export { formatAmount, formatAmountRound };